module.exports = __webpack_public_path__ + "static/media/dk.d29f9c2d.svg";